import React from "react";

import Svg from "@/styles/Svg";
import { isTouchDevice } from "@/utils/getters";

import { OutroPropsExtented, OutroState } from "./index";
import {
  Overlay,
  OverlayClose,
  OverlayContent,
  OverlayLayer,
  OverlayTitle,
  OverlayWrapper,
} from "./styles";

class OutroOverlay extends React.Component<OutroPropsExtented, OutroState> {
  public constructor(props: OutroPropsExtented) {
    super(props);
    this.state = {};
    this.close = this.close.bind(this);
    this.forceClose = this.forceClose.bind(this);
  }
  public render(): JSX.Element {
    const {
      title,
      mode,
      icons,
      withTopPadding,
      alignedToTop,
      noPadding,
    } = this.props;
    const hasImageMode = mode === "image";
    const hasTitle = title && title.length;
    const hasTopPadding = noPadding ? false : withTopPadding || !hasTitle;
    return (
      <Overlay className="overlay" alignTop={alignedToTop} data-qa={"outro"}>
        <OverlayLayer onClick={this.forceClose} />
        <OverlayWrapper noPadding={Boolean(noPadding)}>
          <OverlayContent hasTopPadding={Boolean(hasTopPadding)}>
            {title ? <OverlayTitle>{title}</OverlayTitle> : ""}
            <OverlayClose hasImageMode={hasImageMode} onClick={this.close}>
              <Svg
                contents={hasImageMode ? icons.CloseLite : icons.Close}
                height={18}
                width={18}
              />
            </OverlayClose>
            {this.props.children}
          </OverlayContent>
        </OverlayWrapper>
      </Overlay>
    );
  }
  public open(): void {
    if (this.props.onOpen) {
      this.props.onOpen();
    }
  }
  public forceClose(event: React.MouseEvent | React.TouchEvent): void {
    if (!isTouchDevice()) {
      this.props.onClose();
    }
  }
  public close(event: React.MouseEvent | React.TouchEvent): void {
    this.props.onClose();
  }
}
export default OutroOverlay;
